import { render } from "./collapse.vue?vue&type=template&id=f41bfa8a&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=f41bfa8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f41bfa8a"

export default script